export const API_URL = "https://vaaradhi.agrani.tech";
